import React, { FC, useState } from 'react';
import { Input, message, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import Form from '~/components/Form';
import { changePassword } from '~/api/auth';
// import { passwordMinLength } from '~/pages/login';
// import { apiClient } from '~/api/client';

interface Props {
  open: boolean;
  onClose: () => void;
}

const ChangePassword: FC<Props> = (props) => {
  const { open, onClose } = props;
  const [t] = useTranslation();
  const [form] = Form.useForm();

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const [loading, setLoading] = useState(false);
  const submit = () => form.submit();
  const onFinish = async (values: any) => {
    const { oldPassword, newPassword } = values;
    setLoading(true);
    try {
      await changePassword({
        oldPassword,
        newPassword,
      });
      // await apiClient.passwordManagement(undefined, { oldPassword, newPassword });
      handleClose();
      void message.success(t('passwordUpdated'));
    } catch (error: any) {
      void message.error((error as any).response?.data?.message);
    }
    setLoading(false);
  };

  return (
    <Modal
      title={t('changePassword')}
      confirmLoading={loading}
      visible={open}
      onOk={submit}
      onCancel={handleClose}
    >
      <Form form={form} layout="vertical" size="large" onFinish={onFinish}>
        <Form.Item name="oldPassword" rules={[{ required: true, min: 8 }]}>
          <Input.Password placeholder={t('oldPassword')} />
        </Form.Item>
        <Form.Item name="newPassword" rules={[{ required: true, min: 8 }]}>
          <Input.Password placeholder={t('newPassword')} />
        </Form.Item>
        <Form.Item
          name="newPasswordAgain"
          dependencies={['newPassword']}
          rules={[
            {
              required: true,
            },
            ({ getFieldValue }: any) =>
              ({
                validator(rule: string, value: any) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }

                  // eslint-disable-next-line prefer-promise-reject-errors
                  return Promise.reject(t('passwordsNotMatch'));
                },
              } as any),
          ]}
        >
          <Input.Password placeholder={t('newPasswordAgain')} />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePassword;
